var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "linkedin_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7498"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18861"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18710"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#linkedin_svg__a)",
  "data-name": "Group 18709"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.344 17.436h3.692v11.927h-3.692z",
  "data-name": "Rectangle 7497"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.172 15.875a2.2 2.2 0 1 0-2.183-2.2 2.19 2.19 0 0 0 2.183 2.2",
  "data-name": "Path 27252"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.938 23.1c0-1.677.772-2.676 2.249-2.676 1.358 0 2.01.959 2.01 2.676v6.261h3.675v-7.549c0-3.195-1.811-4.739-4.34-4.739a4.16 4.16 0 0 0-3.594 1.971v-1.607H18.4v11.927h3.542Z",
  "data-name": "Path 27253"
}))))));
export { SvgLinkedin as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin.90a6a12c91360d9f866b59e6a6cecd00.svg";